import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { useFluidFormConfigClient } from './fluidFormConfig.client';
import { useIsSuperAdmin } from '../hooks/useIsSuperAdmin';
export const TemplateToggleButton = ({ formKey, isTemplate, onToggled }) => {
    const client = useFluidFormConfigClient();
    const isSuperAdmin = useIsSuperAdmin();
    const [isToggling, setIsToggling] = useState(false);
    const [error, setError] = useState(null);
    if (!isSuperAdmin) {
        return null;
    }
    const toggle = async () => {
        setError(null);
        try {
            setIsToggling(true);
            const next = !isTemplate;
            await client.setTemplateFlag(formKey, next);
            onToggled?.(next);
        }
        catch (e) {
            const status = e?.response?.status;
            if (status === 403) {
                setError('Super admin required');
                return;
            }
            // @TODO: FLU-193 Handle this.
            setError(e?.response?.data?.error || e?.message || 'Failed to update template flag');
        }
        finally {
            setIsToggling(false);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { display: 'inline-flex' }, title: isTemplate ? 'Remove template' : 'Convert to template' },
            React.createElement(Button, { size: "small", icon: true, basic: !isTemplate, color: isTemplate ? 'green' : undefined, loading: isToggling, disabled: isToggling, onClick: toggle, "aria-label": isTemplate ? 'Remove template' : 'Convert to template' },
                React.createElement(Icon, { name: "clone outline" }))),
        error ? (React.createElement("span", { style: { color: '#dc2626', fontSize: 12 }, title: error }, error)) : null));
};
export default TemplateToggleButton;
